/**
 * Euro item
 * @param {*} editor
 */
function eur(editor) {
  const cm = editor.codemirror;
  const output = '&euro;';
  cm.replaceSelection(output);
}

export default function () {
  const option = {
    name: 'Euro',
    action: eur,
    className: 'fa fa-eur',
    title: 'Euro',
  };

  return option;
}
